var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("PatientProfileModal", {
    attrs: { "is-visible": _vm.isVisible, "patient-data": _vm.patientData },
    on: { "modal:close": _vm.handleCloseModal },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }